import React from 'react'
import { RemoveScroll } from 'react-remove-scroll'
import useResponsiveProp from '../../hooks/useResponsiveProp'
import { useScreenSize } from '../../hooks/useScreenSize'

import { Modal, ModalProps } from '../Private/Modal/Modal'
import { Box } from '../Box/Box'
import { Card } from '../Card/Card'

export interface DialogProps extends Omit<ModalProps, 'position'> {
  width?: ResponsiveProp<'full' | 'content'>
  title?: string
  caption?: string
  inset?: ResponsiveProp<'xs' | 's' | 'm' | 'l' | 'xl' | 'none'>
  radius?: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl'
  overflow?: 'scroll' | 'visible' | 'hidden'
  closeOnClick?: boolean
}

export const Dialog = ({
  children,
  width = 'content',
  title,
  caption,
  inset = 'none',
  radius = 'xxs',
  closeOnClick = true,
  overflow = 'scroll',
  ...restProps
}: DialogProps) => {
  const device = useScreenSize()

  width = useResponsiveProp(width, device)
  inset = useResponsiveProp(inset, device)

  return (
    <Modal position="center" {...restProps} closeOnClick={closeOnClick}>
      <RemoveScroll forwardProps>
        <Box position="relative" pointerEvents="all" width={width === 'full' ? '100%' : undefined}>
          <Card overflow={overflow} title={title} caption={caption} radius={radius} inset={inset}>
            {children}
          </Card>
        </Box>
      </RemoveScroll>
    </Modal>
  )
}
